import fp from 'lodash/fp'
import { combine, withContext, withCallbacks } from 'react-hooks-combine'
import { withFormModel, withMobxAutorun } from 'shared/hooks'
import { spec, validators } from 'utils/validation'
import { ServicesContext } from 'services/context'

import { toOptions } from 'routes/public/events/overview/components/filters/helpers'
import i18next from 'i18next'
import SponsorsFiltersComponent from './component'

const { custom } = validators

// Storage key for persisting filter state
const MARKETING_FILTER_KEY = 'sponsors_marketing_promotion_filter';

// Load saved filter value from localStorage
const loadSavedMarketingFilter = () => {
  try {
    const saved = localStorage.getItem(MARKETING_FILTER_KEY);
    if (saved === 'true') return { id: 'true', name: 'Yes' };
    if (saved === 'false') return { id: 'false', name: 'No' };
  } catch (e) {
    // Silently handle localStorage errors
  }
  return '';
};

export const SponsorsFilters = combine(
  withContext(
    'adminSponsorsService',
    ServicesContext,
    ({ adminSponsorsService }) => adminSponsorsService
  ),

  withFormModel(
    {
      search: {
        initialValue: '',
        spec: spec.flow(custom.valid),
      },
      sportTypes: spec.flow(custom.valid),
      marketingPromotionSelect: {
        initialValue: loadSavedMarketingFilter(),
        spec: spec.flow(custom.valid),
      },
    },
    { id: 'sponsors-filters-form' }
  ),

  withCallbacks(
    {
      loadSportTypes: () => async () => {
        const sportTypes = toOptions(
          i18next.t('enum:sportType', { returnObjects: true })
        )
        return sportTypes
      },
      onSearchRequest: {
        deps: ['debounce', 'onSearch'],
        func: (_state, { debounce, onSearch }) => {
          return fp.isNumber(debounce)
            ? fp.debounce(debounce, onSearch)
            : onSearch
        },
      },
    },
    []
  ),

  withMobxAutorun(
    ({ firstRun, state: { form, onSearchRequest } }) => {
      const search = form.getControl('search')
      const marketingSelectControl = form.getControl('marketingPromotionSelect')

      const sponsorsName = search.value

      // Extract id value from the selected option
      let marketingSelectValue = '';
      try {
        if (marketingSelectControl?.value) {
          if (typeof marketingSelectControl.value === 'object' && marketingSelectControl.value?.id) {
            marketingSelectValue = marketingSelectControl.value.id;
          } else {
            marketingSelectValue = String(marketingSelectControl.value);
          }
        }
      } catch (e) {
        // Error handling silently
      }

      if (firstRun) {
        return
      }

      // Persist the filter value to localStorage
      try {
        if (marketingSelectValue) {
          localStorage.setItem(MARKETING_FILTER_KEY, marketingSelectValue);
        } else {
          localStorage.removeItem(MARKETING_FILTER_KEY);
        }
      } catch (e) {
        // Silently handle localStorage errors
      }

      // Build the query parameters
      const queryParams = {
        sponsorsName,
      };

      // Check dropdown selection and add to query if needed
      if (marketingSelectValue === 'true') {
        queryParams.marketingPromotion = true;
      } else if (marketingSelectValue === 'false') {
        queryParams.marketingPromotion = false;
      }

      onSearchRequest(queryParams);
    },
    ['onSearchRequest']
  )
)(SponsorsFiltersComponent)
